import { Mission, Session, Job } from '../../../db';
import { kmz2kml } from '../../../utils';
import { alertError } from '../../../alertDispatcher';
import { DataSourceOption, IMissionLoader } from '../MissionLoaderCommon';

class ExeMissionLoader implements IMissionLoader {
  async load(session: Session, jobID: string): Promise<Mission | undefined> {
    if (!jobID) {
      alertError('Job ID not found');

      return;
    }

    const job = await Job.getJobRecordById(jobID);

    if (!job) {
      alertError('Job not found');

      return;
    }

    await job.refresh();

    let kmlText = '';
    const dataSource: DataSourceOption = 'Exe Mission';
    const fieldAttachments = await job.get_attachments(dataSource);
    const kmlFile = fieldAttachments[0];

    if (!kmlFile) {
      alertError('No Exe Mission file found for this job');

      return;
    }

    if (kmlFile.filename.endsWith('.kmz')) {
      kmlText = await kmz2kml(kmlFile.content as Blob);
    } else {
      kmlText = await kmlFile.text();
    }

    if (!kmlText) {
      alertError('Exe Mission file is empty');

      return;
    }

    return await session.loadKml(kmlText, jobID, { sampling: false });
  }
}

export default ExeMissionLoader;
